import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { MapPin, ArrowRight } from 'lucide-react';
import { slugify } from '@/lib/utils';

export const AVAILABILITY_MESSAGE =
  "Nos bières sont disponibles chez nos revendeurs partenaires, lors de nos événements et en vente directe à la brasserie à Saint-Rémy-de-Provence. Professionnels : contactez-nous pour obtenir notre grille tarifaire.";

export default function BeerCard({ beer }) {
  const detailUrl = `/nos-bieres/${slugify(beer.name)}`;
  return (
    <div
      className="group relative bg-white rounded-2xl overflow-hidden border border-stone-200 hover:border-primary/30 transition-all duration-300 hover:shadow-xl flex flex-col"
      data-testid={`product-${beer.id}`}
    >
      <Link to={detailUrl} className="relative aspect-[4/3] overflow-hidden block" data-testid={`beer-image-link-${beer.id}`}>
        <img
          src={beer.image_url}
          alt={beer.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-6">
          <h2 className="text-3xl font-heading text-white mb-1 drop-shadow-lg">{beer.name}</h2>
          <p className="text-sm text-white/90 drop-shadow-md">{beer.style}</p>
        </div>
      </Link>

      <div className="p-6 space-y-3 flex flex-col flex-1">
        <p className="text-foreground/70">{beer.short_description}</p>
        {beer.abv && (
          <div className="flex items-center space-x-4 text-sm text-foreground/60">
            <span>ABV : {beer.abv}</span>
            {beer.ibu && <span>IBU : {beer.ibu}</span>}
            <span>Format : {beer.format || '33cl'}</span>
          </div>
        )}
        <p className="text-xs text-foreground/50 border-t border-stone-100 pt-3" data-testid={`availability-note-${beer.id}`}>
          {AVAILABILITY_MESSAGE}
        </p>
        <div className="mt-auto pt-2 space-y-2">
          <Link to={detailUrl}>
            <Button
              variant="outline"
              className="w-full rounded-full font-semibold border-2"
              data-testid={`view-beer-${beer.id}`}
            >
              Voir la fiche
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
          <Link to="/points-de-vente">
            <Button
              className="w-full bg-accent text-accent-foreground hover:bg-accent/90 hover:shadow-md rounded-full font-semibold transition-all"
              data-testid={`find-store-${beer.id}`}
            >
              <MapPin className="w-4 h-4 mr-2" />
              Trouver un point de vente
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
